import {Injectable} from '@angular/core';
import {APIService} from "./api.service";
import _ from 'lodash';
import {ColDef} from "../interfaces/colDef";

@Injectable({
  providedIn: 'root'
})
export class SettingsService extends APIService{

  private readonly settings: any = {user: {}};
  // Saving replaces the whole stored blob, so only a blob loaded for the current user and company may be saved.
  private loaded = false;
  // Bumped by every clear, so a load that answers after an identity change or a newer load is dropped.
  private generation = 0;

  async gatherUserSettings(){
    this.clearUserSettings();
    const generation = this.generation;
    try {
      const user = await this.get('/me/settings');
      if(generation === this.generation){
        this.settings.user = user;
        this.loaded = true;
      }
    } catch (err) {
      // A stale failure must not make the caller clear the newer identity's settings.
      if(generation === this.generation){
        throw err;
      }
    }
  }

  clearUserSettings(){
    this.generation++;
    this.settings.user = {};
    this.loaded = false;
  }

  async saveUserSettings(asRequest: boolean = false){
    if(!this.loaded){
      return false;
    }
    const path = '/me/settings/save';
    if(asRequest){
      return await this.post(path, this.settings.user);
    }
    else{
      const headers = {
        type: 'application/json',
      };

      const blob = new Blob([JSON.stringify(this.settings.user)], headers);
      return navigator.sendBeacon(this.root + path, blob);
    }
  }

  userSetting(key: string, defalt: any = null){
    return (typeof this.settings.user[key] !== 'undefined') ? this.settings.user[key] : defalt;
  }

  mergeTableColumns(key: string, withvalue: ColDef[]){
    const colsetting = this.userSetting(key);
    return withvalue.map(o => {
      const matching = colsetting ? colsetting.find(i => i && i.col === o.name) : null;
      return {
        col: o.name,
        shown: matching ? matching.shown : true
      };
    }).sort((a, b) => {
      return (_.findIndex(colsetting, (o: {col: string, shown: any}) => o && o.col === a.col) || 0)
        - (_.findIndex(colsetting, (o: {col: string, shown: any}) => o && o.col === b.col) || 0);
    });
  }

  putUserSetting(key: string, value: any){
    this.settings.user[key] = _.cloneDeep(value);
  }

  removeUserSetting(key: string){
    delete this.settings.user[key];
  }

  savePageSize(size: number) {
    this.putUserSetting(`table_pagesize`, size);
  }

  get pageSize(): number{
    return this.userSetting('table_pagesize', 25);
  }
}
